import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Kategori.css";
import apiClient from "../components/apiClient";

function Kategori() {
  const [categories, setCategories] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await apiClient.get("/kategori");
        setCategories(response.data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();

    const mediaQuery = window.matchMedia("(max-width: 768px)");
    const handleResize = () => setIsMobile(mediaQuery.matches);
    mediaQuery.addListener(handleResize);
    return () => mediaQuery.removeListener(handleResize);
  }, []);

  const handleCategoryClick = (categoryId) => {
    localStorage.setItem("kategoriId", categoryId);
    navigate(`/produk-kategori/${categoryId}`);
  };

  const renderRow = (items) => (
    <div className="kategori-row">
      {items.map((category) => (
        <div
          key={category.id}
          className="kategori-item"
          onClick={() => handleCategoryClick(category.id)}
        >
          <img
            src={category.image}
            alt={category.nama_kategori}
            className="kategori-image"
          />
          <h6 className="kategori-name">{category.nama_kategori}</h6>
          <span className="kate-name">{category.nama_kategori}</span>
        </div>
      ))}
    </div>
  );

  if (isMobile) {
    return (
      <div className="kategori-container">
        {renderRow(categories.slice(0, 1))} {/* 1 */}
        {renderRow(categories.slice(1, 2))} {/* 1 */}
        {renderRow(categories.slice(2, 3))} {/* 1 */}
        {renderRow(categories.slice(3, 5))} {/* 2 */}
        {renderRow(categories.slice(5, 6))} {/* 1 */}
        {renderRow(categories.slice(6, 8))} {/* 2 */}
        {renderRow(categories.slice(8, 9))} {/* 1 */}
      </div>
    );
  }

  // Desktop layout: 2-2-3-2
  return (
    <div className="kategori-container">
      {renderRow(categories.slice(0, 2))}
      {renderRow(categories.slice(2, 4))}
      {renderRow(categories.slice(4, 7))}
      {renderRow(categories.slice(7, 9))}
    </div>
  );
}

export default Kategori;
